import { resetNotificationsState } from '@/notifications/service';
import { clearStoredDayBriefings } from '@/hooks/useDayBriefingNotifications';
import { clearStoredSmartCues } from '@/hooks/useSmartCueNotifications';
import { clearOfflineCachesOnSignOut } from '@/services/offlineSessionCleanup';

/**
 * Best-effort cleanup for local auth-bound state when the app transitions to signed-out.
 * This should never throw so auth routing can continue even if one cleanup task fails.
 */
export async function runSignedOutSessionCleanup(): Promise<void> {
  await Promise.allSettled([
    resetNotificationsState(),
    clearStoredSmartCues(),
    clearStoredDayBriefings(),
    clearOfflineCachesOnSignOut(),
  ]);
}
